import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=1110cdbc&scoped=true&"
import script from "./HistoryView.vue?vue&type=script&lang=js&"
export * from "./HistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1110cdbc",
  null
  
)

export default component.exports